import { useState } from "react";

import { RiFileExcel2Fill } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";

import { exportExcel } from "@/utils/exports";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { GenericObject } from "@/@types/generics/genericals";
import { HealthUnit } from "@/@types/sintegrada/HealthUnit";
import { RiskClassification } from "@/@types/sintegrada/RiskClassification";

import { BaseModalProps } from "@/components/BaseModal";
import { ClassificationByUbsTable } from "../ClassificationByUbsTable";

type Props = BaseModalProps & {
	aggregatedByHealthUnitAndRiskClassification: ResumeGrouped<
		HealthUnit,
		ResumeGrouped<RiskClassification, object>
	>[];
};

export function ClassificationByUbsModal({
	aggregatedByHealthUnitAndRiskClassification,
	...rest
}: Props) {
	const [isLoadingExportExcel, setIsLoadingExportExcel] = useState(false);

	function handleExportTable() {
		setIsLoadingExportExcel(true);
		if (Object.keys(aggregatedByHealthUnitAndRiskClassification || []).length) {
			const excelData: GenericObject[] = transformDataToExportExcel(
				aggregatedByHealthUnitAndRiskClassification
			);
			exportExcel(excelData, `Tabela`);
		}
		setIsLoadingExportExcel(false);
	}

	function transformDataToExportExcel(
		aggregatedByHealthUnitAndRiskClassification: ResumeGrouped<
			HealthUnit,
			ResumeGrouped<RiskClassification, object>
		>[]
	) {
		// Extrair todas as classificações de risco únicas dos dados
		const riskClassifications = Array.from(
			new Map(
				aggregatedByHealthUnitAndRiskClassification
					.flatMap((healthUnitGroup) => healthUnitGroup.values || [])
					.map((riskClassificationGroup) => [
						riskClassificationGroup.key?.id,
						riskClassificationGroup.key,
					])
			).values()
		).filter(Boolean) as RiskClassification[];

		// Ordenar por ID para manter consistência
		riskClassifications.sort((a, b) => (a.id || 0) - (b.id || 0));

		return aggregatedByHealthUnitAndRiskClassification.map((healthUnitGroup) => {
			const rowData: GenericObject = {
				"Unidade de Saude": healthUnitGroup.key.name || "N/A",
			};

			// Adicionar colunas dinâmicas para cada classificação de risco
			riskClassifications.forEach((riskClassification) => {
				rowData[riskClassification.name] =
					healthUnitGroup.values?.find(
						(riskClassificationGroup) =>
							riskClassificationGroup.key?.id === riskClassification.id
					)?.total || 0;
			});

			return rowData;
		});
	}
	return (
		<Modal size="xl" scrollable {...rest}>
			<Modal.Header className="d-flex justify-content-between" closeButton>
				<Modal.Title>Atendimentos por classificação e UBS</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="d-flex justify-content-end">
					<Col sm={2} md={2} lg={2} xl={2} className="d-flex justify-content-end">
						<Button
							className="justify-content-end"
							variant="secondary"
							onClick={handleExportTable}
							disabled={isLoadingExportExcel}
						>
							<RiFileExcel2Fill />
							Exportar
						</Button>
					</Col>
				</Row>
				<Row className="p-2">
					<ClassificationByUbsTable
						aggregatedByHealthUnitAndRiskClassification={
							aggregatedByHealthUnitAndRiskClassification
						}
					/>
				</Row>
			</Modal.Body>
		</Modal>
	);
}
